import { useMemo } from 'react';
import {
  Modal,
  ModalSizes,
  ButtonVariants,
  Typography,
  TypographyVariants,
  TypographyColors,
} from '@carboledger/ui';
import { useTranslations } from '@/hooks';

/**
 * Props:
 *   open                   whether the modal is shown
 *   onBackToOutbounds      secondary action — returns to the orders list
 *   onGenerateDeclaration  primary action — continues to the declaration flow
 */
export const FulfillSuccessModal = ({ open, onBackToOutbounds, onGenerateDeclaration }) => {
  const t = useTranslations();

  const buttons = useMemo(
    () => [
      {
        label: t('ACTION_BACK_TO_OUTBOUNDS'),
        variant: ButtonVariants.neutral,
        onClick: onBackToOutbounds,
      },
      {
        label: t('ALLOCATIONS_ACTION_GENERATE_DECLARATION'),
        variant: ButtonVariants.primary,
        onClick: onGenerateDeclaration,
      },
    ],
    [t, onBackToOutbounds, onGenerateDeclaration],
  );

  return (
    <Modal
      open={open}
      onClose={onBackToOutbounds}
      size={ModalSizes.small}
      title={t('ORDERS_FULFILL_SUCCESS_TITLE')}
      buttons={buttons}
    >
      <Typography variant={TypographyVariants.bodySm} color={TypographyColors.secondary}>
        {t('ORDERS_FULFILL_SUCCESS_BODY')}
      </Typography>
    </Modal>
  );
};
